import { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * AEO-vriendelijke FAQ-lijst: H3 + zelfstandig leesbaar antwoord (short)
 * + uitgebreide verdieping (long). Default eerste open zodat de short
 * direct zichtbaar is voor crawlers en mensen.
 */
export default function FaqList({ faqs, openByDefault = true }) {
  return (
    <div className="mt-6 space-y-3 font-modern" data-testid="faq-list">
      {faqs.map((f, idx) => (
        <FaqItem key={idx} faq={f} defaultOpen={openByDefault && idx === 0} idx={idx} />
      ))}
    </div>
  );
}

function FaqItem({ faq, defaultOpen, idx }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="rounded-2xl border border-border bg-white overflow-hidden" data-testid={`faq-${idx}`}>
      <button
        type="button"
        className="w-full flex items-start gap-4 text-left px-5 py-4 hover:bg-slate-50/60 transition-colors"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <h3 className="font-editorial text-lg font-semibold text-ink leading-snug flex-1" style={{ letterSpacing: "-0.01em" }}>
          {faq.q}
        </h3>
        <ChevronDown className={`h-4 w-4 text-ink-soft mt-1.5 flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <div className={`px-5 ${open ? "pb-5" : "pb-0 max-h-0 overflow-hidden"}`}>
        <p className="text-ink leading-relaxed text-[15px]">{faq.short}</p>
        {faq.long && (
          <p className="text-ink-soft leading-relaxed text-sm mt-2.5">{faq.long}</p>
        )}
      </div>
    </div>
  );
}
